<template>
<div class="container">
    <!-- SLOT -->
    <slot></slot>

    <!-- Load branding config error message -->
    <!-- <div class="alert alert-danger errorMsg animated slideInRight" role="alert" v-show="showError">
        <strong>Oops!</strong> Could not load configuration
    </div> -->
</div>
</template>

<script>
    export default {
        name: 'AppWrapper',
        props: ['branding'],
        data () {
            return {
                backgroundSize: 'desktop',
                loaded: false,
                showError: false
            }
        },
        created () {
            // this.loadConfig()
        },
        computed: {
            /**
             * Component Classes
             *
             * Figures out what classes should be applied to this componenets top level object
             *
             * @return String list of classes seperated by a space
             */
            componentClasses: function () {
                let classes = []
                if (!this.loaded) {
                    classes.push('app-wrapper--loading')
                } else {
                    classes.push('app-wrapper--loaded')
                }
                return classes.join(' ')
            }
        },
        methods: {
            // Branding related code has been commented out below

            /**
             * Load config
             *
             * This queries the API to get the inital configuration
             *
             */
            // loadConfig: function () {
            //     // On the page load we load the config
            //     this.$http.get('/../../v3/web-application/bookapickup/configuration').then(response => {
            //         // Let's set our default branding. We also want to fix the urls (incase they're relative)
            //         this.branding['general'] = this.fixBrandingUrls(response.data.branding)
            //         // Let's set our default branding. We also want to fix the urls (incase they're relative)
            //         this.branding['current'] = this.fixBrandingUrls(response.data.branding)
            //         // Set our app as being "loaded"
            //         this.loaded = true
            //     }).catch(() => {
            //         // Show an error
            //         this.showError = true;
            //         setTimeout(() => {
            //             this.showError = false;
            //         }, 5000);
            //     })
            // },
            /**
             * Fix Branding URLS
             *
             * As some of the image references passed are relative and absolute paths, we fix them to all be absolute.
             * This code may not be needed in the live environment
             *
             * @param Object tempBranding Contains the branding object returned from the API
             * @return Object Same as tempBranding with URL's fixed
             *
             */
            // fixBrandingUrls: function (tempBranding) {
            //     // Because some of the URL's are relative referneces (/assets/.../img.png)
            //     tempBranding.banner.source = tempBranding.banner.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.banner.source : tempBranding.banner.source
            //     tempBranding.logo.source = tempBranding.logo.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.logo.source : tempBranding.logo.source
            //     tempBranding.backgrounds.mobile.source = tempBranding.backgrounds.mobile.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.backgrounds.mobile.source : tempBranding.backgrounds.mobile.source
            //     tempBranding.backgrounds.tablet.source = tempBranding.backgrounds.tablet.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.backgrounds.tablet.source : tempBranding.backgrounds.tablet.source
            //     tempBranding.backgrounds.laptop.source = tempBranding.backgrounds.laptop.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.backgrounds.laptop.source : tempBranding.backgrounds.laptop.source
            //     tempBranding.backgrounds.desktop.source = tempBranding.backgrounds.desktop.source.startsWith('/') ? (process.env.NODE_ENV === 'development' ? 'http://dev.bookapickup.com.au' : (process.env.NODE_ENV === 'testing' ? 'https://qa.bookapickup.com.au' : 'https://bookapickup.com.au')) + tempBranding.backgrounds.desktop.source : tempBranding.backgrounds.desktop.source
            //     return tempBranding
            // }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 .errorMsg {
     margin-top: 30px;
 }
</style>
